(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["team-bios"] && !Shopify.designMode) return;
  try {
    
/**
 * Fernweh Woodworking Team Bio Slider
 * Updated implementation with animation classes
 */
document.addEventListener('DOMContentLoaded', function() {
  // Log when script loads
  console.log('Fernweh Team Bios script loaded');
  
  // Find the slider
  const teamSlider = document.querySelector('.fernweh-team-slider');
  if (!teamSlider) {
    console.log('No team slider found on page or using grid layout for 7+ members');
    return;
  }
  
  // Get the number of team members
  const teamCount = teamSlider.getAttribute('data-team-count');
  console.log('Team count:', teamCount);
  
  // Get all slides
  const slides = teamSlider.querySelectorAll('.fernweh-slide');
  if (!slides.length) {
    console.log('No slides found in team slider');
    return;
  }
  
  console.log('Found', slides.length, 'slides');
  
  // Set up click handlers for each slide
  slides.forEach(function(slide) {
    slide.addEventListener('click', function() {
      // Don't do anything if already active
      if (slide.classList.contains('active')) {
        return;
      }
      
      // Get the member number
      const memberNumber = slide.getAttribute('data-member');
      console.log('Clicked on member', memberNumber);
      
      // Remove active class from all slides
      slides.forEach(function(s) {
        s.classList.remove('active');
      });
      
      // Add active class to clicked slide
      slide.classList.add('active');
    });
  });
  
  console.log('Fernweh Team Bios slider initialized');
});

  } catch(e) { console.error(e); }
})();
})();
